import React from 'react';
import { useNavigate } from 'react-router-dom';
import LegalFooter from './LegalFooter.jsx';
import { POLICY_VERSION, SUPPORT_EMAIL } from '../utils/legal';
import '../styles/legal.css';
import '../styles/appHeader.css';

const TermsPage = () => {
  const navigate = useNavigate();
  return (
    <div>
      <header className="app-header glass">
        <div className="app-header-logo">
          <button type="button" className="logo-text-home" onClick={() => navigate('/')}>
            LiveNow
          </button>
        </div>
      </header>
      <article className="legal-page">
        <h1>Terms of Service</h1>
        <p className="legal-meta">Version {POLICY_VERSION}. Contact: {SUPPORT_EMAIL}.</p>
        <h2>The service</h2>
        <p>
          LiveNow is a free web app that helps you find live and upcoming events across streaming
          platforms and TV listings. Watch links open the source platform. We do not host the streams.
        </p>
        <h2>Accounts</h2>
        <p>
          You must be able to form a contract in your country. Keep your login details safe. Guest
          search is limited. Reminders, bookmarks, and connected accounts require a free signup.
        </p>
        <h2>Acceptable use</h2>
        <p>
          Do not abuse the API, scrape at scale, or use LiveNow to break the rules of those platforms
          or other sources. We may rate-limit or suspend access that harms the service.
        </p>
        <h2>Content</h2>
        <p>
          Event titles, thumbnails, and links belong to their platforms and rights holders. Listings
          can be wrong or incomplete. LiveNow is provided as-is.
        </p>
        <h2>Contact</h2>
        <p>
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </p>
      </article>
      <LegalFooter />
    </div>
  );
};

export default TermsPage;
